<template>
    <header>
        <main-menu></main-menu>
      
        <div class="main-slider bg-save-us">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <template v-if="loading">
                            <div class="d-flex common-block">
                                <div class="LoaderBalls">
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <swiper class="swiper" :options="swiperOptions">
                                <swiper-slide v-for="(slide, idx) in slides" :key="slide.id">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-7 image">
                                            <img :src="slide.main_image.path" alt=""/>
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-5 main-slider__content">
                                            <div v-html="slide.title"></div>
                                            <div class="swiper-pagination swiper-pagination-progressbar">
                                                <div class="swiper-pagination-progressbar-fill" 
                                                    :style="{width: ((100 / slides.length) * (idx + 1)).toFixed() + '%'}"
                                                ></div>
                                            </div>
                                            <div class="side-text" v-html="slide.data"></div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </template>
                    </div>
                </div>
            </div>
        </div>


    </header>
</template>

<script>

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import { getContentBlock } from './api/get-content-block'

const defaultSlides = 
[
    {
        id: 0, main_image: { path: '/assets/images/baner-1.png' }, title:'<p>Мы запустились!</p> <h1>Создавайте истории вместе с нами</h1>',
        data:'Saveus - это платформа для быстрой, прозрачной и удобной помощи животным и проектам. Находите друзей, создавайте новые истории и меняйте зоозащиту вместе с нами!',
    },
    {
        id: 1, main_image: { path: '/assets/images/baner-2.png' }, title:'<p>Давайте знакомиться!</p> <h1>Присоединяйтесь к нам в Viber и Telegram</h1>',
        data:'Техническая поддержка по всем вопросам платформы, модерации, сбору средств и помощи животным. Почти круглосуточно :) <div class="clearfix"><a style="background: #2e76e4;" target="_blank" class="slider-link" href="https://t.me/joinchat/QcS6iihAtigxYzM6"><img src="/assets/images/icons/tg.svg" alt=""></a><a style="background: #6c4dbb;" target="_blank" class="slider-link" href="https://invite.viber.com/?g2=AQBINbGgYdrMyk0UAgIz8hGEo5Rmx2Ru%2F6fYzwxHqlCQJr6by%2FlwrORiJX87oPFX"><img src="/assets/images/icons/viber.svg" alt=""></a></div>',
    },
    {
        id: 2, main_image: { path: '/assets/images/baner-3.png' }, title:'<p>Журнал о животных и зоозащите</p> <h1>Первый журнал о зоозащите в Беларуси</h1>',
        data:'Факты и статистика, счастливые истории, акции и будущие мероприятия. <a href="http://journal.saveus.by/" target="_blank">Подписывайтесь на обновления!</a>',
    }
]

export default {
    name: 'headermainpage',
    data: () => ({
        loading: false,
        slides:[],
        swiperOptions: {
            slidesPerView: 1,
            spaceBetween: 30,
            fadeEffect: {
                crossFade: true,
            },
            effect: 'fade',
            autoplay: {
                delay: 15000,
                disableOnInteraction: false,
            },
        },
    }),
    CONTEN_BLOCK_NAME: 'main_slider',
    components: {
        Swiper,
        SwiperSlide,
    },

    mounted(){
        this.getSlides()
    },

    methods:{
        getSlides(){
            this.loading = true
            let { CONTEN_BLOCK_NAME } = this.$options

            getContentBlock( CONTEN_BLOCK_NAME )
                .then( 
                    ( { items = [] } ) => {
                        if( items.length ) {
                            this.slides = items.map(
                                it => {
                                    it.main_image.path = `/storage/${it.main_image.path}`
                                    return it
                                }
                            )
                        }
                        if( ! items.length ) this.slides = defaultSlides
                        this.loading = false
                    }
                )
                .catch( 
                    e => {
                        this.slides = defaultSlides
                        this.loading = false
                    }
                )
        }
    }
}
</script>
<style lang="scss" scoped>
.common-block{
    min-height: 450px;
}

</style>
<style lang="scss">


header {
    background: #ffffff;

    .btn {
        padding: 10px 20px;
        background: #2e76e4;
        border-radius: 45px;
        color: #fff;
        font-family: 'Comfortaa', cursive;
        font-size: 12px;
        border: none;
        cursor: pointer;
        margin-right: 16px;
        transition: 0.3s ease;
        text-transform: capitalize;

        &:hover {
            color: #fff;
            opacity: 0.9;
        }
    }
    .main-slider__content{
        padding: 215px 15px 60px;
        height: 616px;
    }
    .bg-save-us {
        background-image: url('/assets/images/main_page/SAVE_US.svg');
        background-repeat: no-repeat;
        background-position: top 20px right;
        background-size: 65%;
        font-family: 'Comfortaa', cursive;

        .image {
            img {
                position: absolute;
                left: 0;
                bottom: 0;

            }
        }

        p {
            color: #2e76e4;
            font-size: 12px;
            text-transform: uppercase;
        }

        h1 {
            color: #333333;
            font-weight: bold;
            font-size: 40px;
        }

        .watch-video {
            margin: 15px 0;
            display: block;

            img {
                margin-right: 7px;
            }
        }
    }

    .slide-text {
        font-weight: 400;
        font-size: 15px;
    }

    .slider-link{
        float: left;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        padding: 5px;
        border-radius: 50%;
        margin: 7px 7px 0 0;
        transition: opacity .2s ease;
        img{
            width: 100%;
            max-width: 18px;
            height: auto;
        }

        &:hover{
            opacity: .8;
        }
    }
}

.swiper-slide {
    transition-duration: 0.8s !important;
}

.swiper-pagination {
    position: absolute;
    margin: 20px 0;

    &-progressbar {
        position: static;
        //width: 100% !important;
        height: 2px !important;
        border-radius: 5px;

        &-fill {
            height: 2px;
            background: #2e76e4 !important;
            transform: scale(1) !important;
        }
    }
}

@media screen and (max-width: 992px) {
    header .bg-save-us .image img{
        position: static;
        left: unset;
        bottom: unset;
        width: 100%;
        max-width: 300px;
    }

    header .main-slider__content{
        height: auto;
        padding: 30px 15px;
    }

}


@media screen and (max-width: 768px){
    header .bg-save-us .image img{
        display: block;
        margin: 0 auto;
    }

    header .bg-save-us h1{
        font-size: 22px;
        line-height: 26px;
    }

    header .main-slider__content{
        text-align: center;
        font-size: 13px;

        .clearfix {
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
        }
    }
}

</style>
